export const CONFIG_PAYLOAD=[
    "tracking"
]